import React from 'react'
import StagesManager from '../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import ProductsApplet from "./Applets/CommerceApplet";
import FinanceApplet from "./Applets/FinanceApplet";
import ConnectionsApplet from "./Applets/ConnectionsApplet";
import CommissionsApplet from "./Applets/CommissionsApplet";
import BookingApplet from "./Applets/BookingApplet";
import SettingsApplet from "./Applets/SettingsApplet";
import Cookies from "universal-cookie";

import Responsive from '../components/Responsive';

import { nanoid } from 'nanoid';
import HttpServices from '../utils/Http.services';
import { ManagePages } from '../variables/ManagePages';
import CustomLoader from '../components/CustomLoader';
import { getObject, imageAddress, setObject, translate } from '../utils/useful';
import CommerceApplet from './Applets/CommerceApplet';

import DatabaseApplet from './Applets/DatabaseApplet';
import MessengerApplet from './Applets/MessengerApplet';
import AutomationsApplet from './Applets/AutomationsApplet';
import DeskApplet from './Applets/DeskApplet';
import DriveApplet from './Applets/DriveApplet';
import InquiriesApplet from './Applets/InquiriesApplet';
import store from '../stores/storeConfig';
import DevelopersApplet from './Applets/DevelopersApplet';
import EmailApplet from './EmailApplet';
import RoomApplet from './Applets/RoomApplet';

class Applet extends React.Component {
    state = {
        hasAdminAccess: false,
        adminView: false,
        rootUrl: '',
        permissions: {},
        currentApplet: '',
        pageStatus: null,
        // appletAccess:true
    }

    setCurrentApplet = (key, value) => {
        // console.log('keeeeeeeeeeeeeey', key)
        // console.log('vaaaaaaaaaaaaaal', value)
        this.setState({ [key]: value }, () => {
            this.setState({ currentApplet: value }, () => {
                this.init()
                // let headerConfig = this.state.headerConfig
                // headerConfig.isPortal = false
                // headerConfig.frames = this.props.frames
                // this.setState({ headerConfig })
            })
            // this.filterSelectApplet(this.state.currentApplet)
        })
    }

    // filterSelectApplet = (current) => {
    //     let messengerList = []
    //     let messengers = this.props.messengers.list
    //     let filteredMessenger = this.state.filteredMessenger
    //     // console.log("currrrrrrrrrrrre", current)
    //     if (current == '') {
    //         messengerList = messengers
    //         filteredMessenger = messengers
    //     }
    //     else {
    //         filteredMessenger = []
    //         messengers.forEach((element) => {
    //             let found = false
    //             console.log('messenger', element)
    //             element.applets?.forEach((prop) => {
    //                 console.log('prop.applet', prop.applet)
    //                 console.log('currentApplet', current)
    //                 if (prop.applet == current) {
    //                     found = true
    //                 }
    //             })
    //             console.log(found)
    //             if (found) {
    //                 messengerList.push(element)
    //                 filteredMessenger.push(element)
    //             }
    //         });

    //     }
    //     this.props.setMessenger(null)
    //     this.setState({ messengerList, filteredMessenger })
    // }
    componentDidMount() {

        this.init()
        // console.log("componentDidMount AP", this.props)
        // const cookies = new Cookies();
        // let token = cookies.get('token');
        // if (token) {
        //     this.setState({ isLoading: true,hasToken:true })
        //     this.waitForId(10)
        // } else {
        //     this.setState({ pageStatus: 401 })
        // }

        // console.log("componentDidMount")

    }


    // waitForId = (leftAttempt) => {
    //     console.log("waitForId")
    //     if (this.props.user?.info?._id) {
    //         this.setState({ isLoading: false, }, () => {
    //             this.init()
    //             // let accessPages = Object.values(ManagePages)
    //             // this.setState({ modules: accessPages })
    //         })
    //     } else {
    //         setTimeout(() => {
    //             if (leftAttempt != 0) {
    //                 this.waitForId(leftAttempt - 1)
    //             } else {
    //                 // this.props.actions.logoutUser()
    //                 this.setState({ pageStatus: 401 })
    //             }
    //         }, 500);
    //     }
    // }


    componentDidUpdate(prevProps) {
        // console.log('appllertt', this.props.lastSelected);

        if (JSON.stringify(this.props.data.path) != JSON.stringify(prevProps.data.path)) {
            // console.log('hereeeeeeeeeeeeeeeapp');
            this.init()
        }
    }

    closeWindow = () => {
        this.props.closeWindow(this.props.windowId)
    }

    init() {

        // console.log("INIT A")

        let slug
        let username
        let path = this.props.data?.path

        if (this.props.data?.params?.id) {
            slug = this.props.data?.params?.id
        }

        if (path && path[0]) {
            username = path[0]
            slug = path[1]

            if (username == 'a') {
                username = null
            }
        }
        // { console.log('baseurllllllllllll22', username, slug) }

        let rootUrl = "/" + path[0] + "/" + path[1]

        // if () {

        // }
        // console.log('rootURL IS', rootUrl)
        // console.log(username)
        // console.log(slug)

        if (rootUrl != this.state.rootUrl) {
            if (this.stageManager) {
                this.stageManager.changeStage(0)
            }
            this.setState({ applet: {}, rootUrl, oldData: this.props.data, slug, username }, () => {
                if (slug) {
                    this.fetchApplet(slug, username)
                }
            })
        }
    }
    makeAppletPermissions = (newPermission, type, permission) => {

        //fullaccess
        // console.log('permissions[i]', permissions[i])
        if (permission.permissions == '*') {
            setObject(newPermission, type, '*')

        }
        else if (newPermission[type] != '*' && permission.permissions) {
            //section
            for (const [sKey, sValue] of Object.entries(permission.permissions)) {
                if (sValue == '*') {
                    newPermission[type][sKey] = '*'
                    setObject(newPermission[type], type, {})
                }
                else if (newPermission[type][sKey] != '*') {
                    if (!newPermission[type][sKey]) newPermission[type][sKey] = {}
                    //permission
                    for (const [pKey, pValue] of Object.entries(sValue)) {
                        // console.log('pVlauiifd', pValue, pKey, typeof pValue == 'object')
                        if (pValue == '*') {
                            newPermission[type][sKey][pKey] = '*'
                        }
                        else if (newPermission[type][sKey][pKey] != '*' && typeof pValue == 'object') {

                            if (!newPermission[type][sKey][pKey]) {
                                newPermission[type][sKey][pKey] = {}
                            }
                            for (const [nKey, nValue] of Object.entries(pValue)) {
                                if (!newPermission[type][sKey][pKey][nKey]) {
                                    newPermission[type][sKey][pKey][nKey] = true
                                }
                            }
                        }
                        else {
                            newPermission[type][sKey][pKey] = true
                        }
                    }
                }

            }
        }
        return newPermission
    }
    makeCollectionPermissions = (newPermission, type, permission) => {
        if (permission.permissions) {
            if (permission?.permissions == '*') {
                newPermission[type][permission.collectionId] = '*'

            }
            else if (newPermission[type][permission.collectionId] != '*' && permission?.permissions) {
                for (const [sKey, sValue] of Object.entries(permission.permissions)) {

                    if (sValue == '*') {
                        newPermission[type][permission.collectionId][sKey] = '*'
                    }
                    else if (newPermission[type][permission.collectionId][sKey] != '*') {
                        if (!newPermission[type][permission.collectionId][sKey]) newPermission[type][permission.collectionId][sKey] = {}
                        for (const [pKey, pValue] of Object.entries(sValue)) {
                            if (pValue == '*') {
                                newPermission[type][permission.collectionId][sKey][pKey] = '*'
                            }
                            else if (newPermission[type][permission.collectionId][sKey][pKey] != '*' && typeof pValue == 'object') {

                                if (!newPermission[type][permission.collectionId][sKey][pKey]) {
                                    newPermission[type][permission.collectionId][sKey][pKey] = {}
                                }
                                for (const [nKey, nValue] of Object.entries(pValue)) {
                                    if (!newPermission[type][permission.collectionId][sKey][pKey][nKey]) {
                                        newPermission[type][permission.collectionId][sKey][pKey][nKey] = pValue ?? true
                                    }
                                }
                            }
                            else {

                                newPermission[type][permission.collectionId][sKey][pKey] = sValue ?? true
                            }
                        }
                    }

                }
            }
        }
        // console.log('colllecc', newPermission)
        return newPermission
    }
    makeAUtomationPermissions = (newPermission, permission) => {
        // console.log('permission', permission)
        if (!newPermission[permission.automationId]) {
            newPermission[permission.automationId] = {}
        }
        if (!newPermission[permission.automationId][permission.stageId] || newPermission[permission.automationId][permission.stageId] == '*') {
            newPermission[permission.automationId][permission.stageId] = {}
        }
        newPermission[permission.automationId][permission.stageId] = permission.permission?.permissions ?? permission.permissions
        return newPermission

    }
    normalizePermissions = (roots, cb) => {
        let newPermission = {}
        // let combinedPermissions = {}
        for (let i = 0; i < roots.length; i++) {
            for (let x = 0; x < roots[i].permissions.length; x++) {
                let type = roots[i].permissions[x].permission.type ?? 'applet'
                if (type == 'frames') {
                    type = `frames.${roots[i].permissions[x].permission.collectionId}`
                }
                // if (!getObject(newPermission, type)) {
                //     setObject(newPermission, type, {})
                // }
                // switch (type) {
                //     case 'applet':

                //         this.makeAppletPermissions(newPermission, type, roots[i].permissions[x].permission)
                //         break;

                //     case 'collection':

                //         this.makeCollectionPermissions(newPermission, 'collection', roots[i].permissions[x].permission)
                //         break;

                //     case 'automation':

                //         this.makeAUtomationPermissions(newPermission, type, roots[i].permissions[x].permission)
                //         break;

                //     default:
                //         break;
                // }
                if (!getObject(newPermission, type)) {
                    // console.log('newPermissionTp1', JSON.parse(JSON.stringify(newPermission)), type)
                    setObject(newPermission, type, {})
                    // console.log(setObject(newPermission, type, '*'))
                    // newPermission[type] = {}
                }
                // console.log('roots[i].permissions[x]', newPermission)
                // console.log('newPermissionTp2', JSON.parse(JSON.stringify(newPermission)))
                //fullaccess
                // console.log('permissions[i]', roots[i].permissions[x].permission)

                // for (let c = 0; c < roots[i].permissions[x].permission?.permissions.length; c++) {
                // console.log(roots[i].permissions[x].permission.type,'roots[i].permissions[x].permission?.permissions', roots[i].permissions[x].permission?.permissions)
                if (roots[i].permissions[x].permission?.permissions == '*') {
                    setObject(newPermission, type, '*')
                    // console.log('newPermissionTp3', JSON.parse(JSON.stringify(newPermission)))
                }
                else if (newPermission[type] != '*' && roots[i].permissions[x].permission?.permissions) {
                    //section
                    for (const [sKey, sValue] of Object.entries(roots[i].permissions[x].permission?.permissions)) {
                        if (sValue == '*') {

                            // setObject(newPermission, type, '*')
                            setObject(newPermission, (type + '.' + sKey), '*')
                            // newPermission[type][sKey] = '*'
                        }

                        else if (getObject(newPermission, type + '.' + sKey) != '*') {
                            if (!getObject(newPermission, type + '.' + sKey)) {
                                setObject(newPermission, (type + '.' + sKey), {})

                                // newPermission[type][sKey] = {}
                            }
                            //permission
                            for (const [pKey, pValue] of Object.entries(sValue)) {
                                if (pValue == '*') {
                                    newPermission = setObject(newPermission, type + '.' + sKey + '.' + pKey, '*')

                                    // newPermission[type][sKey][pKey] = '*'
                                }
                                else if (getObject(newPermission, type + '.' + sKey + '.' + pKey) != '*' && typeof pValue == 'object') {

                                    if (!getObject(newPermission, type + '.' + sKey + '.' + pKey)) {
                                        newPermission = setObject(newPermission, type + '.' + sKey + '.' + pKey, {})
                                        // newPermission[type][sKey][pKey] = {}
                                    }
                                    for (const [nKey, nValue] of Object.entries(pValue)) {
                                        if (!getObject(newPermission, type + '.' + sKey + '.' + pKey + '.' + nKey)) {
                                            newPermission = setObject(newPermission, type + '.' + sKey + '.' + pKey + '.' + nKey, true)
                                            // newPermission[type][sKey][pKey][nKey] = true
                                        }
                                    }
                                }
                                else {
                                    newPermission = setObject(newPermission, type + '.' + sKey + '.' + pKey, true)
                                    // newPermission[type][sKey][pKey] = true
                                }
                            }
                        }

                    }
                }
                // }

            }

        }
        this.setState({ permissions: newPermission })
        if (cb) {
            cb(newPermission)
        }

        //excepations

        // console.log('newPermission', newPermission)


    }
    updateConnectionPermissions = (connections) => {
        // console.log('*updateConnectionPermissions')
        let selectedConnection
        let appletAccess = false
        connections.forEach((element) => {
            // console.log('elementelement', element)
            if (!element.public) {
                selectedConnection = element
            }
            if (!element.public && element.status == 'C') {
                appletAccess = true
            }
        })
        // console.log('selectedConnection', selectedConnection)
        if (selectedConnection) {
            // this.normalizePermissions(selectedConnection.roots ?? [])
        }
        this.setState({ appletAccess })
    }
    fetchApplet(slug, username, isUpdate) {

        // console.log("fetchApplet", slug, username)
        let body = {}

        if (username) {
            body.username = username
            body.slug = slug
        } else {
            body.urlcode = slug
        }

        // console.log(body)


        // console.log('getOneApplet here2', body)
        if (!isUpdate) {
            this.setState({ isLoadingPage: true })
        }

        HttpServices.request('getOneApplet', body, (fetchResult, fetchError, fetchStatus) => {
            // console.log('getOneApplet', fetchResult, fetchError)
            this.setState({ isLoadingPage: false })
            // console.log(fetchError)
            if (fetchError) {
                this.setState({ pageStatus: 404 })
                return
            }

            store.dispatch(actions.updateUsedConnection(fetchResult.connections))

            this.updateConnectionPermissions(fetchResult.connections)
            if (fetchResult.permissions) {
                this.setState({ permissions: fetchResult.permissions })
            }
            this.setState({ isLoadingPage: false })
            // if (fetchError && slug != 'automations') {
            //     // console.log('herre Error')
            //     this.setState({ pageStatus: 404 })
            //     return
            // }
            // console.log(fetchResult.connections)
            if (!fetchResult.connections || fetchResult.connections.length == 0) {
                this.setState({ pageStatus: 401 })
                return
            }

            // console.log("fetchResult", fetchResult)
            // console.log("setWindowInfo", fetchResult?.applet)
            this.props.setWindowInfo({ title: fetchResult?.applet?.hub?.fullname, icon: imageAddress(fetchResult?.applet?.hub?.image, 'profile', 'mini') })

            // console.log(fetchResult)
            if (fetchResult?.applet || slug == 'automations') {
                let type = fetchResult.applet.features[0]
                if (fetchResult.applet.features.some(e => ['Tasking', 'Database', 'Drive', 'Messenger', 'Calendar', 'Rooms', 'Booking', 'Finance', 'Settings', 'Commerce'].includes(e))) {
                    // if (fetchResult.applet.features.some(e => ['Tasking', 'Database', 'Drive', 'Messenger', 'Calendar', 'Rooms'].includes(e))) { 'Commerce', 

                    type = 'Database'
                }
                if (!type && fetchResult?.applet?.type) {
                    type = fetchResult?.applet?.type
                }

                let hasAdminAccess = false
                let adminView = false
                let connections = fetchResult?.connections
                // console.log("connections **", connections)
                // let permissions = Array.isArray(fetchResult?.connections) ? fetchResult?.connections[0]?.permissions : fetchResult?.connections?.permissions
                let canSwitch = false
                for (let i = 0; i < connections.length; i++) {

                    this.checkAdminAccess(fetchResult?.applet, connections[i], hasAdminAccess, adminView, fetchResult, 0, (scanSwitch) => {
                        // console.log('TP1',scanSwitch)
                        if (scanSwitch) {
                            canSwitch = true
                        }
                    })


                    for (let x = 0; x < connections[i].roots?.length; x++) {


                        if (connections[i].roots) {
                            let permissions = connections[i].roots
                            // console.log('connectsdf', connections[i].roots[x].permissions)

                            // permissions.map(item => {
                            //     console.log('yoooo')
                            //     // console.log('item?.permission', item?.permission)
                            //     if (item?.permission?.adminAccess == true && !fetchResult?.applet?.features?.includes('Rooms')) {
                            //         // console.log('=============')
                            //         hasAdminAccess = true
                            //         adminView = true
                            //         this.setWindowButtons()

                            //     }
                            //     else if (fetchResult?.applet?.features?.includes('Rooms')) {
                            //         hasAdminAccess = true
                            //         adminView = true
                            //     }
                            // })
                            // console.log(permissions)
                            // console.log(fetchResult)
                            // console.log('permissions==', permissions)
                            if (permissions == null) {
                                permissions = fetchResult?.connection?.permissions
                            }
                            if (slug == 'automations') {
                                fetchResult = {}
                                permissions = [{ test: true }]
                                fetchResult.applet = { name: 'Automations' }
                                type = 'Automations'
                            }

                            // if (permissions) {
                            //     console.log('PERMISSION`1', permissions)
                            //     permissions.forEach(item => {
                            //         if (item?.permission?.adminAccess == true) {
                            //             hasAdminAccess = true
                            //             adminView = true
                            //             this.setWindowButtons()

                            //         }
                            //     })
                            // }
                            // console.log(hasAdminAccess)
                        }

                    }
                }

                // console.log("Here", canSwitch)
                // console.log("setWindowInfo", fetchResult?.applet)

                this.props.setWindowInfo({ title: fetchResult?.applet?.hub?.fullname, icon: imageAddress(fetchResult?.applet?.hub?.image, 'profile', 'mini') })
                setTimeout(() => {
                    this.setWindowButtons(canSwitch)
                }, 50);
                // this.setWindowButtons(canSwitch)



                // console.log('fetchResult.applet', fetchResult.applet)
                let frames = fetchResult.frames

                if (!frames && fetchResult.applet?.frames) {
                    frames = []
                    fetchResult.applet.frames.forEach(element => {
                        frames.push(element.frame)
                    });
                }

                // console.log("frames",frames)
                // let admin
                // fetchResult.connections.map((element) => {
                //     if (element.adminAccess) {
                //         admin = true
                //     }
                // })
                // let rootUrl = this.state.rootUrl
                // // console.log('fetchResult.connections', fetchResult.connections)
                // if (admin) {
                //     rootUrl = rootUrl + '/admin'
                // }

                this.setState({ hasAdminAccess, adminView, connection: (Array.isArray(fetchResult.connections) ? fetchResult.connections[0] : fetchResult.connections), automations: fetchResult.automations, connections: fetchResult.connections, applet: fetchResult.applet, frames: frames, userSettings: fetchResult.userSettings, title: fetchResult.applet.name, pageStatus: 200 }, () => {

                    // if()
                    if (!isUpdate) {
                        this.stageManager.changeStage(type)
                    }

                })
            }
        })
    }
    checkAdminAccess = (applet, connection, hasAdminAccess, adminView, fetchResult, index, cb) => {


        // console.log("checkAdminAccess", connection, connection.adminAccess)
        let canSwitch = false
        if (connection) {
            if (connection.adminAccess == true && connection.type == 'applet') {
                // console.log('=============')
                hasAdminAccess = true
                adminView = true

                // if (applet.defaultPage) {
                canSwitch = true
                // }
            }

            // cb()
            // else if (fetchResult?.applet?.features?.includes('Rooms')) {
            //     hasAdminAccess = true
            //     adminView = true
            // }
            // if (hasAdminAccess) {
            //     if (cb) {
            //         cb()
            //     }
            // } else {
            //     this.checkAdminAccess(permissions, hasAdminAccess, adminView, fetchResult, (index + 1), cb)
            // }
        }
        // console.log(canSwitch)


        //  else {
        //     if (cb) {
        //         cb()
        //     }
        // }

        if (cb) {
            cb(canSwitch)
        }

    }
    getUserSettings = () => {
        let obj = {}
        HttpServices.request('getUserSettings', obj, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            let userSettings = {}
            // let showStack = false
            // if (prop.type == 'boards' || prop.type == 'kanban' || prop.type == 'matrix' || prop.type == 'pivot' || prop.type == 'calendar') {
            //     showStack = true
            // }
            // this.setState({ showStack }, () => {
            // })
            // let currentView = JSON.parse(JSON.stringify(this.state.currentView))
            // //CHECK
            // if (!currentView.settings) {
            //     currentView.settings = {}
            // }
            if (fetchResult.info) {
                userSettings = fetchResult.info?.values ?? {}
                // Object.entries(fetchResult.info?.values ?? {}).map(([key, value]) => {
                //     userSettings[key] = value
                // })
            }
            // else {
            //     currentView.settings = {}
            // }
            // currentView = JSON.parse(JSON.stringify(currentView))
            this.setState({ userSettings }, () => {
                this.props.setHeader('updateId', nanoid())
            })
        })
    }

    frameUpdateActions = (frame, action, cb) => {


        // console.log('*frameUpdateActions')

        this.fetchApplet(this.state.slug, this.state.username, true)
        // console.log('frameUpdateActions', action)
        // let frames = this.state.frames
        // switch (action) {
        //     case 'append':
        //         // console.log('framefirst', frame)
        //         frames.push(frame)
        //         break;
        //     case 'edit':
        //         frames.map((element, index) => {
        //             let frameId = frame?._id ?? frame
        //             if (element._id == frameId) {
        //                 Object.entries(frame).map(([key, value]) => {
        //                     frames[index][key] = value
        //                 })

        //             }
        //         })
        //         break;

        //     case 'delete':
        //         let found
        //         let cIndex
        //         frames.map((element, index) => {
        //             if (element._id == frame) {
        //                 found = true
        //                 cIndex = index
        //             }
        //         })
        //         frames.splice(cIndex, 1)
        //         break;

        //     default:
        //         break;
        // }
        // this.setState({ frames }, () => {
        //     if (cb) {
        //         cb()
        //     }
        // })
    }



    setWindowButtons = (canSwitch) => {

        // console.log("setWindowButtons")
        let buttons = []
        if (canSwitch) {
            buttons.push({ name: 'switchView', icon: '/assets/icons/useful/switchView1.png' })
        }
        this.props.setWindowButtons(buttons)
    }

    switchView = () => {
        // console.log("switchView")
        this.setState({ adminView: !this.state.adminView })
    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }


    userUpdated = (info) => {
        let applet = this.state.applet
        // applet.user = { ...info }
        this.setState({
            applet: {
                ...this.state.applet,
                user: info
            }
        })
        // console.log("this.userUpdated")
        // console.log(info)
        // console.log(applet)
    }



    changeWindowLink = (nPath, cb) => {
        let path = this.props.data?.path
        // console.log('pathhhhhhhhhhh', path)
        // console.log('pathhhhhhhhhhhn', nPath)
        path = [path[0], path[1]]

        // if (nPath != null && !path.includes(nPath[0])) {
        //     path = [...path, ...nPath]
        // }
        if (nPath != null) {
            // path = [...path, ...nPath]
            for (let i = 0; i < nPath.length; i++) {
                if (nPath[i] != path[path.length - 1] || this.state.applet.slug == 'settings') {
                    path.push(nPath[i])
                }
            }
        }

        // console.log('applll', path)
        this.props.changeWindow('applet', { path: path })
        if (cb) {
            cb()
        }
    }
    removeWindowLink = (npath) => {
        let path = this.props.data?.path
        // console.log('first', path)
        path.pop()
        // console.log('third', path)
        this.props.changeWindow('applet', { path: path })

    }
    updateUserSettings = (data) => {
        let userSettings = JSON.parse(JSON.stringify(this.state.userSettings))
        let found
        let cIndex
        // console.log('befSETTING',JSON.parse(JSON.stringify(userSettings)))
        userSettings.map((element, index) => {
            if (element._id == data._id) {
                found = true
                cIndex = index
            }
        })
        if (found) {
            userSettings[cIndex] = data
        } else {
            userSettings.push(data)
        }
        // console.log('afterSETTING',JSON.parse(JSON.stringify(userSettings)))
        this.setState({ userSettings })
    }
    setData = (key, value, reference, cb) => {
        // console.log('setDataApplet')
        if (reference == 'Applet') {
            let firstKey = key.split('.')[0]
            let object = this.state//getObject(this.state, firstKey)
            let newObj = setObject(object, key, value)
            // console.log('before',object)
            // let newObj = setObject(object, elseKey, value)
            this.setState({ [newObj[firstKey]]: newObj[firstKey] }, () => {
                // console.log('first[newObj[firstKey]]', [newObj[firstKey]], this.state[newObj[firstKey]])
                if (cb) {
                    cb()
                }
            })
        }
    }


    goToHub = () => {
        let username = this.state.applet?.hub?.username
        this.props.changeWindow('hub', { path: [username] })
    }



    render() {

        if (this.state.isLoadingPage) {
            return (
                <div className='flexcc w-100 h-100'>
                    <CustomLoader isLoading={this.state.isLoadingPage} color={'#007aff'} height={18} width={18} />
                    <p className='mld-3'>{translate("Is Loading")}</p>
                </div>
            )
        } else if (this.state.pageStatus == 404) {
            return (
                <div className='flexcc pt-5'>
                    <p>{translate("Applet does not exist")}</p>
                </div>
            )
        } else if (this.state.pageStatus == 401) {
            return (
                <div className='flexcc pt-5'>
                    <p>{translate("Permission Denied")}</p>
                </div>
            )
        } else {

            let appletHub = typeof this.state.applet?.hub == 'object' ? this.state.applet?.hub?._id : this.state.applet?.hub
            let username = this.state.applet?.hub?.username
            let appletSlug = this.state.applet?.slug
            let variables = {
                applet: this.state.applet,
                hub: this.state.applet?.hub,

                appletId: this.state.applet?._id,
                appletHub: appletHub,
                username: this.state.applet?.hub?.username,
                appletSlug: appletSlug,
                targetId: appletHub,

                appletSettings: {
                    calendarType: 'jalali',
                    currency: 'ریال',
                    decimalPlaces: 0
                },

            }

            if (this.state.applet?.relatedApplets && this.state.applet?.relatedApplets.length > 0) {

                // console.log(this.state.applet?.relatedApplets)
                variables.relatedApplets = this.state.applet?.relatedApplets.reduce((acc, item) => {
                    acc[item.name.replace('{{lang}}', '')] = item.applet;
                    return acc;
                }, {});
            }
            let isDesktop = this.props.isDesktop
            let isMobile = this.props.isMobile
            // { console.log('baseurlllllllllllll', this.state.applet) }
            // console.log('this.state.applet',this.state.applet)
            // console.log(this.props.width)

            return (
                <div className="w-100 d-flex Applet h-100 window-content-radius "  >

                    <div className=' w-100 h-100 window-content-radius'>

                        <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >


                            {/* <SettingsApplet stage={1} stageName={'Settings'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} userUpdated={this.userUpdated} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <AutomationsApplet stage={1} stageName={'Automations'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} userUpdated={this.userUpdated} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <FinanceApplet stage={1} stageName={'Finance'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <CommerceApplet stage={1} stageName={'Commerce'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <EmailApplet stage={1} stageName={'Email'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />

                            <BookingApplet stage={1} stageName={'Booking'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <DatabaseApplet stage={1} stageName={'Database'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} removeWindowLink={this.removeWindowLink} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <InquiriesApplet stage={1} stageName={'Inquiry'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} removeWindowLink={this.removeWindowLink} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <MessengerApplet stage={1} stageName={'Messenger'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <DeskApplet stage={1} stageName={'Tasking'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} setWindowInfo={this.props.setWindowInfo} />
                            <DriveApplet stage={1} stageName={'Drive'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} setWindowInfo={this.props.setWindowInfo} />
                            <DevelopersApplet stage={1} stageName={'Developer'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} addNewWindow={this.props.addNewWindow} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} setWindowInfo={this.props.setWindowInfo} /> */}


                            <SettingsApplet stage={1} stageName={'Settings'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug, 'admin']} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} userUpdated={this.userUpdated} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} appletAccess={this.state.appletAccess} />
                            <AutomationsApplet stage={1} stageName={'Automations'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} userUpdated={this.userUpdated} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <FinanceApplet stage={1} stageName={'Finance'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <CommerceApplet stage={1} stageName={'Commerce'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} appletAccess={this.state.appletAccess} />
                            <ConnectionsApplet stage={1} stageName={'Connections'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} updateUserSettings={this.updateUserSettings} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            {/* <CommissionsApplet stage={1} stageName={'Commissions'} adminView={this.state.adminView} setCurrentApplet={this.setCurrentApplet} setData={this.setData} windowData={this.props.data} route={this.state.rootUrl} applet={this.state.applet} connection={this.state.connection} user={this.props.user} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} /> */}
                            <EmailApplet stage={1} stageName={'Email'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />

                            <BookingApplet stage={1} stageName={'Booking'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <DatabaseApplet stage={1} stageName={'Database'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} removeWindowLink={this.removeWindowLink} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} updateConnectionPermissions={this.updateConnectionPermissions} appletAccess={this.state.appletAccess} closeWindow={this.closeWindow} userSettings={this.state.userSettings} frameUpdateActions={this.frameUpdateActions} automations={this.state.automations} />
                            <DriveApplet stage={1} stageName={'Drive'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} removeWindowLink={this.removeWindowLink} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} setWindowInfo={this.props.setWindowInfo} data={this.props.data} />
                            <RoomApplet stage={1} stageName={'Rooms'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} removeWindowLink={this.removeWindowLink} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} />
                            <InquiriesApplet stage={1} stageName={'Inquiry'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} removeWindowLink={this.removeWindowLink} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} appletAccess={this.state.appletAccess} />
                            {/* <MessengerApplet stage={1} stageName={'Messenger'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} appletAccess={this.state.appletAccess} /> */}
                            <DeskApplet stage={1} stageName={'Tasking'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} setWindowInfo={this.props.setWindowInfo} appletAccess={this.state.appletAccess} />
                            <DevelopersApplet stage={1} stageName={'Developer'} isDesktop={isDesktop} isMobile={isMobile} baseUrl={[username, appletSlug]} setCurrentApplet={this.setCurrentApplet} setData={this.setData} variables={variables} language={this.props.language} adminView={this.state.adminView} windowData={this.props.data} permissions={this.state.permissions} data={this.props.data} route={this.state.rootUrl} applet={this.state.applet} frames={this.state.frames} connection={this.state.connection} user={this.props.user} updateUserSettings={this.updateUserSettings} lastSelected={this.props.lastSelected} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} addNewWindow={this.props.addNewWindow} location={this.props.location} changeWindowLink={this.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.goToHub} width={this.props.width} height={this.props.height} setWindowInfo={this.props.setWindowInfo} />
                            {/* <AccountingApplet stage={0} stageName={'Database'} windowData={this.props.data} setData={this.setData} route={this.state.rootUrl} applet={this.state.applet} connection={this.state.connection} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} goToHub={this.goToHub} width={this.props.width} /> */}
                            {/* <BookingApplet stage={1} stageName={'Database'} windowData={this.props.data} setData={this.setData} route={this.state.rootUrl} applet={this.state.applet} connection={this.state.connection} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} goToHub={this.goToHub} width={this.props.width} /> */}
                            {/* <ProductsApplet stage={0} stageName={'Database'} windowData={this.props.data} setData={this.setData} route={this.state.rootUrl} applet={this.state.applet} connection={this.state.connection} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} history={this.props.history} location={this.props.location} changeWindowLink={this.changeWindowLink} goToHub={this.goToHub} width={this.props.width} /> */}
                        </StagesManager >
                    </div >
                </div >
            )
        }
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Applet);
